import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { setPendingModal } from "../../../libs/pending-modal";

const searchSchema = z.object({
  // amount
  a: z.union([z.string(), z.number()]).transform(Number),
});

type Search = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_authed/transfer/accept/$transferCode")({
  validateSearch: (search: Search) => searchSchema.parse(search),
  beforeLoad: ({ context: { tenant } }) => {
    if (!tenant.feature.transfer) {
      throw redirect({ to: "/", replace: true });
    }
  },
  loaderDeps: ({ search: { a } }: { search: Search }) => ({
    amount: a,
  }),
  loader: async ({ params: { transferCode }, deps: { amount } }) => {
    const data: TransferInInitiatedModalState = {
      type: "transfer-in-initiated",
      data: { transferCode, amount },
    };
    setPendingModal(data);

    return redirect({ to: "/", replace: true });
  },
});
